import { toast } from "sonner";

/**
 * Copy text to the clipboard and show a success/error toast.
 * Falls back to `document.execCommand("copy")` when the Clipboard API
 * is unavailable (e.g. non-HTTPS or older browsers).
 */
export async function copyToClipboard(
  text: string,
  successMessage = "Copied!",
): Promise<boolean> {
  // Prefer the modern Clipboard API (requires secure context / HTTPS)
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(successMessage);
      return true;
    } catch {
      // Permission denied or transient failure — fall through to legacy path
    }
  }

  // Fallback for insecure contexts or when Clipboard API is unavailable
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  const success = document.execCommand("copy");
  document.body.removeChild(textarea);
  if (success) {
    toast.success(successMessage);
  } else {
    toast.error("Copy failed");
  }
  return success;
}
